import { render, staticRenderFns } from "./sms-login-form.vue?vue&type=template&id=12fb8617"
import script from "./sms-login-form.vue?vue&type=script&lang=js"
export * from "./sms-login-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports